import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatInTimeZone } from 'date-fns-tz';
import { Button } from '@a-ui/react';
import classNames from 'classnames';

import { fetchPaymentsCard } from 'actions/payments';

import styles from './Payments.module.css';

const PAGE_SIZE = 8;

const Payments = ({ cardNumber }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [localPayments, setLocalPayments] = useState([]);
  const { payments } = useSelector(state => ({
    payments: state.payments,
  }));

  const onLoadMore = () => {
    dispatch(fetchPaymentsCard(cardNumber, page + 1, PAGE_SIZE)).then((response) => {
      const { hasNextPage, pageNumber, payments = [] } = response.payload;
      setPage(pageNumber);
      setShowLoadMore(hasNextPage);
      setLocalPayments(prevPayments => [
        ...prevPayments,
        ...payments,
      ]);
    });
  }

  useEffect(() => {
    onLoadMore()
  }, []);

  if (payments.items.length === 0) {
    return (
      <p className="u-margin-top">Er is nog geen betalingshistoriek.</p>
    )
  }

  return (
    <div>
      <table className={classNames('a-table', 'u-margin-top-xs', styles.table)}>
        <thead className={styles.thead}>
          <tr>
            <th>Datum</th>
            <th>Betaald via</th>
            <th className="u-text-right">Bedrag</th>
          </tr>
        </thead>
        <tbody>
          {
            localPayments.map((item, index) => (
              <tr key={`payments-${index}`}>
                <td className="small">{formatInTimeZone(item.timestamp, 'Europe/Brussels', 'dd/MM/yyyy HH:mm')} u</td>
                <td className="small">{item.paymentTypeFrontend}</td>
                <td className="small u-text-right">€ {item.amount.toFixed(2).toString().replaceAll('.', ',')}</td>
              </tr>
            ))
          }
        </tbody>
      </table>
      {showLoadMore && <span className={styles.loader}><Button
        {...(payments.loading && {
          addOn: {
            type: 'spinner',
          },
        })}
        emphasis="low"
        onClick={onLoadMore}
      >Meer laden</Button></span>}
    </div>
  );
}

export default Payments;
